import App from '../index.js';

App.Users = (function () {

    let datatable,
        elDatatable = $('#users_table');

    function initDataTable () {
        if(!elDatatable[0]) return;

        let options = {
            destroy: true,
            serverSide: true,
            processing: true,
            searching: true,
            deferRender: true,
            stateSave: false,
            pageLength: 25,
            lengthChange: false,
            language: {
                searchPlaceholder: "Search",
                search: "",
            },
            layout: {
                topStart: { div: { className: 'table-headline' } },
                topEnd: 'search',
                bottomStart: 'info',
                bottomEnd: 'paging',
            },
            initComplete: function () {
                $('#users_table_holder .table-headline').html($('#users_table_headline').html());
                $('#users_table_holder .dt-search [type="search"]').removeClass('form-control-sm').closest('label').addClass('form-group search-box').prepend('<i class="search-icon fas fa-search"></i>');
                $('#users_table_holder .dt-search .form-group, #users_table_holder .dt-search .search-box').wrapAll('<div class="form-row justify-content-end align-items-center text-end"></div>');

            },
            order: [[ 0, "desc" ]],
            ajax: {
                url: elDatatable.data('query-url'),
                type: "POST",
                data: function (d) {
                    d._token = $('meta[name="csrf-token"]').attr('content');
                }
            },
            columns: [
                {
                    data: 'date',
                    searchable: true,
                    orderable: true,
                    className: 'datatable-created_at'
                },
                {
                    data: 'name',
                    orderable: false,
                    className: 'datatable-name'
                },
                {
                    data: 'organization_name',
                    orderable: false,
                    className: 'datatable-name'
                },
                {
                    data: 'email',
                    orderable: false,
                    className: 'datatable-name'
                },
                {
                    data: 'user_type',
                    orderable: false,
                    className: 'datatable-user-type'
                },
                {
                    data: 'action',
                    orderable: false,
                    searchable: false,
                    className: 'datatable-action'
                }
            ]
        };

        datatable = elDatatable.DataTable(options);
    }

    function deleteUser () {

    }

    return {
        init: function(){
            initDataTable();
            App.dataTableTypeDelay($('#users_table_holder .dt-search input[type="search"]'));

            $('body').on('click', '.delete-user', function () {
                let name = $(this).data('user-name');
                let route = $(this).data('url');
                $('form').attr('action', route);
                $('.header-sub-text').html(`Are you sure you want to delete user ${name}`);
            });

            $('#deleteUser').on('hide.bs.modal', function () {
                $('.header-sub-text').empty();
            });
        }
    };

})();

// Provide the route name
App.registerRoute('users.index', App.Users.init);

export default App.Users;
